import { MutationTree } from 'vuex';
import {
  FiduciaryAnalysis,
  FundAnalysis,
  OrganisationAnalysis,
  Paginated,
  PaginatedV2,
  SchemeAnalysis,
  SubfundAnalysis,
  SubmissionSummary
} from '../types';
import * as MT from './mutationsTypes';
import { IAnalysisState } from './state';
/*--------------------------------------------------/
 * Analysis Mutations
 *--------------------------------------------------*/
export const AnalysisMutations: IAnalysisMutations = {
  [MT.SET_FETCHING_FUND_ANALYSIS]: (
    state: IAnalysisState,
    fetchingFundAnalysis: boolean
  ) => (state.fetchingFundAnalysis = fetchingFundAnalysis),

  [MT.SET_FUND_ANALYSIS]: (
    state: IAnalysisState,
    data: Paginated<FundAnalysis>
  ) => (state.fundAnalysis = data),

  [MT.SET_SCHEME_ANALYSIS]: (
    state: IAnalysisState,
    data: PaginatedV2<SchemeAnalysis>
  ) => (state.schemeAnalysis = data),

  [MT.SET_SUBMISSION_SUMMARY]: (
    state: IAnalysisState,
    data: SubmissionSummary
  ) => (state.submissionSummary = data),

  [MT.SET_SUBFUND_ANALYSIS]: (
    state: IAnalysisState,
    data: PaginatedV2<SubfundAnalysis>
  ) => (state.subfundAnalysis = data),

  [MT.SET_CONSULTANT_ANALYSIS]: (
    state: IAnalysisState,
    data: OrganisationAnalysis
  ) => (state.consultantAnalysis = data),

  [MT.SET_PROVIDER_ANALYSIS]: (
    state: IAnalysisState,
    data: OrganisationAnalysis
  ) => (state.consultantAnalysis = data),

  [MT.SET_FIDUCIARY_ANALYSIS]: (
    state: IAnalysisState,
    data: PaginatedV2<FiduciaryAnalysis>
  ) => (state.fiduciaryAnalysis = data)
};

/*--------------------------------------------------/
 * Analysis Mutations Tree Interface
 *--------------------------------------------------*/
export interface IAnalysisMutations extends MutationTree<IAnalysisState> {
  [MT.SET_FETCHING_FUND_ANALYSIS](
    state: IAnalysisState,
    fetchingFundAnalysis: boolean
  ): void;

  [MT.SET_FUND_ANALYSIS](
    state: IAnalysisState,
    data: Paginated<FundAnalysis>
  ): void;

  [MT.SET_SCHEME_ANALYSIS](
    state: IAnalysisState,
    data: PaginatedV2<SchemeAnalysis>
  ): void;

  [MT.SET_SUBMISSION_SUMMARY](
    state: IAnalysisState,
    data: SubmissionSummary
  ): void;

  [MT.SET_SUBFUND_ANALYSIS](
    state: IAnalysisState,
    data: PaginatedV2<SubfundAnalysis>
  ): void;

  [MT.SET_CONSULTANT_ANALYSIS](
    state: IAnalysisState,
    data: OrganisationAnalysis
  ): void;

  [MT.SET_PROVIDER_ANALYSIS](
    state: IAnalysisState,
    data: OrganisationAnalysis
  ): void;

  [MT.SET_FIDUCIARY_ANALYSIS](
    state: IAnalysisState,
    data: PaginatedV2<FiduciaryAnalysis>
  ): void;
}
